import { get , post } from "@utils/axios";
import sessionService from "./session.service";


class CommonService {

    getOfficeDropdown({timePeriod , regions}: {timePeriod ?: string , regions ?: Array<string>}) {
        const body = {
          ...(timePeriod && {timePeriod : timePeriod}),
          regions : regions
        }
        return post(`${sessionService.getClient()?.appServiceUrl}/common/dependent-dropdown/office`, body);
      }
    
      getInsuranceDropdown({timePeriod , officeIds}: {timePeriod : string , officeIds : Array<string>}) {
        const body = {
          ...(timePeriod && {timePeriod : timePeriod}),
          officeIds : officeIds
        }
        return post(`${sessionService.getClient()?.appServiceUrl}/common/dependent-dropdown/insurance`, body);
      }

      getRegion({timePeriod }: {timePeriod ?: string}){
        const body = {
          ...(timePeriod && {timePeriod : timePeriod})
        }
        return post(`${sessionService.getClient()?.appServiceUrl}/common/dependent-dropdown/region`, body);
      }

    getKeyVaultValues (keys: string | string[]) {
      const body = {
        keys: [].concat(keys as any)
      }
      return post(`${sessionService.getClient()?.appServiceUrl}/common/key-vault-values`, body)
    }
}

export default new CommonService();
